export default __webpack_public_path__ + "locales/ja-JP/Files.json?hash=43b3580bff40e91091f76fd5bfadc71d";